import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges
} from "@angular/core";

interface IMessage {
  type: "info" | "warning" | "success" | "error";
  message: string;
}

@Component({
  selector: "kwikui-messages",
  templateUrl: "./messages.component.html",
  styleUrls: ["./messages.component.scss"]
})
export class KwikUIMessagesComponent implements OnInit, OnChanges {
  @Input() id = "";

  @Input() messages: IMessage[] = [];

  constructor() {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.hasOwnProperty("messages") && !changes.messages.firstChange) {
      this.messages = changes.messages.currentValue;
    }
  }

  ngOnDestroy(): void {
    // ensure when component is destroyed the subscription is also and not left open.
  }

  handleOnClickMessage(e: any) {
    this.messages.splice(e, 1);
  }
}
